
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"12","height":"12","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.9 11.908a.896.896 0 0 1-.637-.265.897.897 0 0 1 0-1.274l4.415-4.414-4.415-4.417a.897.897 0 0 1 0-1.272.896.896 0 0 1 1.273 0l5.053 5.053a.9.9 0 0 1 0 1.274l-5.053 5.052a.898.898 0 0 1-.636.263zm-4.998 0a.896.896 0 0 1-.637-.265.897.897 0 0 1 0-1.274l4.413-4.414L.264 1.538a.9.9 0 0 1 0-1.274.899.899 0 0 1 1.275.001l5.05 5.053a.898.898 0 0 1 0 1.274l-5.051 5.051a.895.895 0 0 1-.636.264z","fill":"#FFF"}})])
      }
    
      }
    